export default "__VITE_ASSET__Bxam4crz__"